import { IsOptional } from "class-validator";

export class EnvMobileAppOptionsDto {
  @IsOptional()
  app_name?: string; // by convention initialized to <customer_handle>-<environment-handle>
}
